// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { OrgRef, OrgRefT, verifyOrgRef } from "./org-ref";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /roles/light/:orgId — minimal role info with nested org.
 * Matches Go: `models.RoleLight { Name, DisplayName, Organization{ID,Name}, ID }`
 */
export class RoleLight implements flatbuffers.IUnpackableObject<RoleLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RoleLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRoleLight(bb: flatbuffers.ByteBuffer, obj?: RoleLight): RoleLight {
    return (obj || new RoleLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRoleLight(bb: flatbuffers.ByteBuffer, obj?: RoleLight): RoleLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RoleLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  displayName(): string | null;
  displayName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  displayName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  organization(obj?: OrgRef): OrgRef | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new OrgRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startRoleLight(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addDisplayName(builder: flatbuffers.Builder, displayNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, displayNameOffset, 0);
  }

  static addOrganization(builder: flatbuffers.Builder, organizationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, organizationOffset, 0);
  }

  static endRoleLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): RoleLightT {
    return new RoleLightT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.displayName(),
      this.organization() !== null ? this.organization()!.unpack() : null,
    );
  }

  unpackTo(_o: RoleLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.displayName = this.displayName();
    _o.organization = this.organization() !== null ? this.organization()!.unpack() : null;
  }

  unpackFields(...fields: string[]): RoleLightT {
    const t = new RoleLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("display_name")) {
      t.displayName = this.displayName();
    }
    if (fieldSet.has("organization")) {
      t.organization = this.organization() !== null ? this.organization()!.unpack() : null;
    }
    return t;
  }
}

export class RoleLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public displayName: string | Uint8Array | null = null,
    public organization: OrgRefT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const displayName = this.displayName !== null ? builder.createString(this.displayName!) : 0;
    const organization = this.organization !== null ? this.organization!.pack(builder) : 0;

    RoleLight.startRoleLight(builder);
    RoleLight.addId(builder, id);
    RoleLight.addName(builder, name);
    RoleLight.addDisplayName(builder, displayName);
    RoleLight.addOrganization(builder, organization);

    return RoleLight.endRoleLight(builder);
  }

  clone(): RoleLightT {
    const obj = new RoleLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.displayName = this.displayName;
    obj.organization = this.organization !== null ? this.organization!.clone() : null;
    return obj;
  }

  equals(other: RoleLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.displayName !== other.displayName) return false;
    if (this.organization !== null && other.organization !== null) {
      if (!this.organization!.equals(other.organization!)) return false;
    } else if (this.organization !== other.organization) return false;
    return true;
  }
}

export function verifyRoleLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyOrgRef(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
